import styles from '../RoomDiscount.module.scss';

type RevenueShareProps = {
  currencyFormatter: (value: number) => string;
  basePrice: number;
  discountPercent: number;
};

export const RevenueShare = ({
  currencyFormatter,
  basePrice,
  discountPercent,
}: RevenueShareProps) => (
  <>
    <span className={styles.discountedPrice}>
      {currencyFormatter(Math.round(basePrice * (1 - discountPercent / 100)))}
    </span>
    <span className={styles.originalPrice}>
      {currencyFormatter(Math.round(basePrice))}
    </span>
  </>
);
